import { Link } from 'react-router-dom'

export default function Forbidden() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="text-center flex flex-col items-center gap-4">
        <p className="text-8xl font-black text-accent">403</p>
        <h1 className="text-2xl font-bold text-fg">Доступ запрещён</h1>
        <p className="text-sm max-w-xs text-muted">
          У вас недостаточно прав для просмотра этой страницы
        </p>
        <Link
          to="/"
          className="px-6 py-3 rounded-xl font-bold text-sm transition-all hover:opacity-90 bg-accent text-on-accent mt-2"
        >
          На главную
        </Link>
      </div>
    </div>
  )
}
